import React from 'react';
import { useIntl } from 'react-intl';

import Layout from 'components/Layout';
import Title from 'components/ui/Title';

import Albums from 'features/albums/Albums';
import Dvds from 'features/dvds/Dvds';

import {
  Wrapper
} from './AlbumsPage.styles';

const AlbumsPage = () => {
  const intl = useIntl();

  return (
    <Layout>
      <Wrapper>
        <Title size="big" color="secondary">
          {intl.formatMessage({ id: 'albums.title' })}
        </Title>
        <Albums />
      </Wrapper>
      <Wrapper>
        <Title size="big" color="secondary">
          {intl.formatMessage({ id: 'dvds.title' })}
        </Title>
        <Dvds />
      </Wrapper>
    </Layout>
  );
};

export default AlbumsPage;
